export default function Pricing() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-form');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2332] mb-4">
            料金の目安
          </h2>
          <p className="text-sm sm:text-base text-[#ff6b35] font-semibold">
            現場数、書類量により割引があります。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12">
          <div className="bg-[#fafaf8] rounded-3xl p-6 sm:p-10 hover:shadow-xl transition-all">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <i className="ri-file-text-line text-3xl sm:text-4xl text-[#ff6b35]"></i>
              <h3 className="text-xl sm:text-2xl font-bold text-[#1a2332]">技能者登録1人〜</h3>
            </div>
            <div className="mb-4 sm:mb-6">
              <span className="text-4xl sm:text-5xl font-bold text-[#1a2332]">¥15,000</span>
              <span className="text-lg sm:text-xl text-gray-600 ml-2">〜</span>
            </div>
            <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-700">
                <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span>施工体制台帳作成</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-700">
                <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span>安全書類一式</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-700">
                <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span>グリーンサイト登録</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-700">
                <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span>最短即日対応</span>
              </li>
            </ul>
          </div>

          <div className="bg-[#1a2332] rounded-3xl p-6 sm:p-10 hover:shadow-xl transition-all relative overflow-hidden">
            <div className="absolute top-4 sm:top-6 right-4 sm:right-6">
              <div className="px-3 sm:px-4 py-1.5 sm:py-2 bg-[#ff6b35] rounded-full text-white text-xs sm:text-sm font-bold whitespace-nowrap">
                おすすめ
              </div>
            </div>
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <i className="ri-calendar-line text-3xl sm:text-4xl text-[#ff6b35]"></i>
              <h3 className="text-xl sm:text-2xl font-bold text-white">月額サポート</h3>
            </div>
            <div className="mb-4 sm:mb-6">
              <span className="text-4xl sm:text-5xl font-bold text-white">¥80,000</span>
              <span className="text-lg sm:text-xl text-gray-400 ml-2">〜</span>
            </div>
            <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-300">
                <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span>複数現場対応</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-300">
                <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span>書類作成無制限</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-300">
                <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span>電子システム管理代行</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-300">
                <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                <span>優先対応・専任担当者</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center">
          <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8 px-4">
            ※現場数・書類量により変動いたします。まずは無料相談をご利用ください。
          </p>
          <button 
            onClick={scrollToContact}
            className="px-8 sm:px-10 py-3 sm:py-4 bg-[#ff6b35] text-white text-base sm:text-lg font-bold rounded-full hover:bg-[#e55a2b] transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer shadow-lg"
          >
            料金の詳細を問い合わせる
            <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
